import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  label?: string;   // optional, default "Loading"
  height?: number;  // optional, same as SubmitButton
  bg?: string;      // optional, default "primary"
}

export default function LoadingButton({ label = "Loading", height, bg }: Props) {
  const {t} = useTranslation();
  return (
    <div>
      <button
        type="button"
        className={`
          ${bg ? `bg-${bg}` : "bg-primary"} 
          text-white 
          px-6 
          ${height ? `h-[${height}px]` : "h-[44px]"} 
          text-xl 
          w-full 
          rounded-[8px] 
          capitalize 
          font-semibold 
          cursor-wait 
          transition 
          hover:bg-opacity-85
        `}
        disabled
      >
        {t("login.loginLoading")}...
      </button>
    </div>
  );
}
